export const CREATE_COMPANY_MUTATION = `
  mutation CreateCompany($data: companies_insert_input!) {
    insert_companies_one(object: $data) {
      id
      name
      email_address_of_representative
      name_of_representative_
      phone_of_representative
      created_at
      updated_at
    }
  }
`;

export const UPDATE_COMPANY_MUTATION = `
  mutation UpdateCompany($id: Int!, $data: companies_set_input!) {
    update_companies_by_pk(pk_columns: {id: $id}, _set: $data) {
      id
      name
      email_address_of_representative
      name_of_representative_
      phone_of_representative
      created_at
      updated_at
    }
  }
`;

export const DELETE_COMPANY_MUTATION = `
  mutation DeleteCompany($id: Int!) {
    delete_companies_by_pk(id: $id) {
      id
      name
    }
  }
`;
